export default __webpack_public_path__ + "static/media/section2-4-img2.c07202c8.png";